import React from 'react';
import project11 from '../../images/Project Image/image11.png';
import project12 from '../../images/Project Image/image12.png';
import project13 from '../../images/Project Image/image13.png';
import project21 from '../../images/Project Image/image21.png';
import project22 from '../../images/Project Image/image22.png';
import project23 from '../../images/Project Image/image23.png';
import project31 from '../../images/Project Image/image31.png';
import project32 from '../../images/Project Image/image32.png';
import style from './Projects.module.scss';
import ProjectCard from '../ProjectCard/ProjectCard';

const projects = [
  {
    id: 1,
    projectImg: [project11, project12, project13],
    projectName: "Riders",
    projectDetails: "Motorcycle Web based App is a A Fullstack Website. Features: 1. A user can make orders & review with dynamic ratings of the products. 2. A user sends mail to the admin using emailJs. ",
    technology: ["react-native", "material-ui", "nodejs", "mongodb", "firebase"],
    websiteLink: "https://rider-mern.web.app/",
    clientCodeLink: "https://github.com/webfaisalbd/rider-react-client",
    serverCodeLink: "https://github.com/webfaisalbd/rider-react-server"
  },
  {
    id: 2,
    projectImg: [project21, project22, project23],
    projectName: "Food Lover",
    projectDetails: "A Food delivery Web App is a Fullstack Website. Features: 1. A user can make different amounts of orders. 2. Get total cost including vats. 3.Manages the orders.",
    technology: ["react-native", "bootstrap","nodejs",  "mongodb", "firebase"],
    websiteLink: "https://food-lover-mern.web.app/",
    clientCodeLink: "https://github.com/webfaisalbd/food-lover-react-client",
    serverCodeLink: "https://github.com/webfaisalbd/food-lover-react-server"
  },
  {
    id: 3,
    projectImg: [project31, project32, project32],
    projectName: "E-Medicine",
    projectDetails: "A Healthcare Web App is a simple frontend based website. Features: 1. A user can order products. 2. Without login, User can't order. 3. After login, it redirects your location.",
    technology: ["react-native","bootstrap","html-5--v1", "css3", "firebase"],
    websiteLink: "https://e-medicine-react.web.app/",
    clientCodeLink: "https://github.com/webfaisalbd/e-medicine-react",
    serverCodeLink: ""
  }
]

const Projects = () => {
  return (
    <div className={style.projects} id="projects">
      <div className="container ">
        <div className="projectTitle text-center">
          <h1>My Projects</h1>
        </div>
        <div className="row mt-3">
          {
            projects.map(project => <ProjectCard key={project.id} project={project}></ProjectCard>)
          }
        </div>
      </div>
    </div>
  );
};

export default Projects;